/**
 * 
 * 
 *
 */

import fragment from './artifacts.glsl';

var ArtifactDrawing = function (artifactA) {
    

    PIXI.AbstractFilter.call(this);

    this.passes = [this];
    
    var numberOfPixels = 7;
    if( numberOfPixels > 128 ){
        numberOfPixels = 128;
    }

    var wh = [0.75, 0.005];
    var arrayOfPx = this.generatePixels(numberOfPixels, wh);

    this.uniforms = {
        dimensions :        {type: '4f' , value: [0.0,0.0,0.0,0.0]},
        pxwh :              {type: '2f', value: wh},
        numberOfPixels:     {type: '1f', value: numberOfPixels },
        pixels:             {type: '4fv', value: arrayOfPx },
        artifactA:          { type: 'sampler2D', value: artifactA.texture }
    };

    this.fragmentSrc = fragment;

};

ArtifactDrawing.prototype = Object.create(PIXI.AbstractFilter.prototype);
ArtifactDrawing.prototype.constructor = ArtifactDrawing;



Object.defineProperties(ArtifactDrawing.prototype, {
    dimensions : {
        get: function() {
            return this.uniforms.dimensions.value;
        },
        set : function(value) {
            this.dirty = true;
            this.uniforms.dimensions.value = value;
        }
    },

    pxwh : {
        get: function() {
            return this.uniforms.pxwh.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.pxwh.value = value;
        }
    },

    numberOfPixels : {
       
    }
});


module.exports = ArtifactDrawing;


/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/artifacts.js
 **/